/**
 * Represents object in the string format key-value
 * { X_(xxx): 'foo', Y_(xxx): 'bar' } -> 'X: foo
 *                            Y: bar'
 * @param obj
 */
export const fromObjToStringFields = (obj) => {
  let result = '';

  Object.keys(obj).forEach(key => {


    result += `${key.slice(0, key.lastIndexOf('_'))}: ${obj[key]}\n`;
  });

  return result;
};

export const toArray = pojo => {
  return (
    Object.keys(pojo).map(key => pojo[key])
  );
};


// WEBPACK FOOTER //
// ./src/helpers/strings.js